import { useCallback, useEffect, useState } from 'react';

export const MOBILE_NAVIGATION_STYLE_KEY = 'naraMobileNavigationStyle';
export const MOBILE_NAVIGATION_STYLES = {
  PILL: 'pill',
  STANDARD: 'standard',
};

const CHANGE_EVENT = 'nara-mobile-navigation-style-change';

const normalizeStyle = (value) => (
  Object.values(MOBILE_NAVIGATION_STYLES).includes(value)
    ? value
    : MOBILE_NAVIGATION_STYLES.PILL
);

const readStyle = () => {
  try {
    return normalizeStyle(JSON.parse(localStorage.getItem(MOBILE_NAVIGATION_STYLE_KEY)));
  } catch (error) {
    return MOBILE_NAVIGATION_STYLES.PILL;
  }
};

export const useMobileNavigationStyle = () => {
  const [style, setStyleState] = useState(readStyle);

  useEffect(() => {
    const sync = (event) => {
      const nextValue = event?.detail || readStyle();
      setStyleState(normalizeStyle(nextValue));
    };
    window.addEventListener('storage', sync);
    window.addEventListener(CHANGE_EVENT, sync);
    return () => {
      window.removeEventListener('storage', sync);
      window.removeEventListener(CHANGE_EVENT, sync);
    };
  }, []);

  const setStyle = useCallback((nextStyle) => {
    const normalized = normalizeStyle(nextStyle);
    localStorage.setItem(MOBILE_NAVIGATION_STYLE_KEY, JSON.stringify(normalized));
    setStyleState(normalized);
    window.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: normalized }));
  }, []);

  return [style, setStyle];
};
